import { useEffect } from "react";
import OneSignal from "react-onesignal";

export default function OneSignalSetup() {
  useEffect(() => {
    const initOneSignal = async () => {
      try {
        await OneSignal.init({
          appId:
            "4cb94fa8-0eff-42c0-a503-bcce81c416b9",

          safari_web_id:
            "web.onesignal.auto.0919e572-6b9a-4fc1-8566-50f787b3e729",

          notifyButton: {
            enable: true,
          },

          allowLocalhostAsSecureOrigin: true,
        });

        console.log(
          "OneSignal Initialized"
        );

        // ASK USER PERMISSION
        const permission =
          await OneSignal.Notifications.requestPermission();

        console.log(
          "Permission:",
          permission
        );

        // GET PLAYER ID
        const playerId =
          await OneSignal.User.PushSubscription.id;

        console.log(
          "Player ID:",
          playerId
        );
      } catch (error) {
        console.error(
          "OneSignal Error:",
          error
        );
      }
    };

    initOneSignal();
  }, []);

  return null;
}